import { Link } from 'react-router-dom';

const links = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Contact', href: '/contact' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
];

export default function Footer() {
  const handleTopNavigation = (href: string) => {
    if (href === '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  return (
    <footer className="bg-[#1E1B4B] text-white relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#38BDF8]/10 rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#F472B6]/10 rounded-full translate-x-1/3 translate-y-1/3" />
      <div className="absolute top-1/2 left-1/2 w-40 h-40 bg-[#FBBF24]/5 rounded-full -translate-x-1/2 -translate-y-1/2" />

      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-10 h-10 flex items-center justify-center relative">
                <div className="absolute inset-0 bg-[#38BDF8] rounded-xl rotate-6" />
                <div className="absolute inset-0 bg-[#FBBF24] rounded-xl -rotate-3" />
                <span className="relative text-white font-black text-lg z-10">G</span>
              </div>
              <span className="font-black text-lg">
                Grandeur <span className="text-[#38BDF8]">Architect</span>
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              大阪発のクリエイティブ広告代理店。<br />
              あなたのブランドを、もっと楽しく、<br />
              もっと輝かせます！
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <p className="text-xs font-black uppercase tracking-widest mb-5 text-[#FBBF24]">Navigation</p>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3">
              {links.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    onClick={() => handleTopNavigation(link.href)}
                    className="text-sm text-white/60 hover:text-[#38BDF8] transition-colors cursor-pointer font-medium"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <p className="text-xs font-black uppercase tracking-widest mb-5 text-[#F472B6]">Company Info</p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#38BDF8]/20 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#38BDF8] text-xs" />
                </div>
                <p className="text-white/60 text-xs leading-relaxed">〒530-0043 大阪市北区天満四丁目１４番２ー５０２号</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#F472B6]/20 flex-shrink-0">
                  <i className="ri-user-line text-[#F472B6] text-xs" />
                </div>
                <p className="text-white/60 text-xs">山内　紫央里</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#A3E635]/20 flex-shrink-0">
                  <i className="ri-mail-line text-[#A3E635] text-xs" />
                </div>
                <p className="text-white/60 text-xs break-all">info.customer@grandeur-architect.com</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#FB923C]/20 flex-shrink-0">
                  <i className="ri-phone-line text-[#FB923C] text-xs" />
                </div>
                <p className="text-white/60 text-xs">050-8895-1393 / 080-2943-2049</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#FBBF24]/20 flex-shrink-0">
                  <i className="ri-calendar-line text-[#FBBF24] text-xs" />
                </div>
                <p className="text-white/60 text-xs">設立：令和3年7月21日</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#F472B6]/20 flex-shrink-0">
                  <i className="ri-time-line text-[#F472B6] text-xs" />
                </div>
                <p className="text-white/60 text-xs">月〜金 9:00〜18:00</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Grandeur Architect株式会社. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            {['#38BDF8', '#FBBF24', '#F472B6', '#A3E635'].map((c) => (
              <span key={c} className="w-2 h-2 rounded-full" style={{ background: c }} />
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
